define(function(require) {
  const IpsModel = require('civicsBase/ipsModel');
  const IpsModelCollection = require('civicsBase/ipsModelCollection');

  return IpsModelCollection.extend({
    urlRoot: '/delegate/civics-api/api/cdr/attachmentconstraints/{0}/{0}',
    url: function(){
      return this.urlRoot.format(this.type,this.applicationTypeId);
    }
  });
});
